var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinkLinesHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194.51 133.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_38);}.cls-2{fill:url(#Degradado_sin_nombre_38-2);}.cls-3{fill:url(#Degradado_sin_nombre_38-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_38",
    x1: 74.82,
    y1: 115.22,
    x2: 0,
    y2: 115.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f49e8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f7b7a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbdccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fef2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fffaec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_38-2",
    x1: 194.51,
    y1: 18.52,
    x2: 119.69,
    y2: 18.52,
    xlinkHref: "#Degradado_sin_nombre_38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_38-3",
    x1: 173.74,
    y1: 67.28,
    x2: 26.87,
    y2: 67.28,
    xlinkHref: "#Degradado_sin_nombre_38"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.3,96.69H17.17v.06a18.51,18.51,0,0,0,0,36.93v.06H56.3a18.53,18.53,0,0,0,0-37.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176,0H136.86V.05a18.52,18.52,0,0,0,0,36.94v0H176a18.52,18.52,0,0,0,0-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.22,48.76H44v.05a18.52,18.52,0,0,0,0,36.94v0H155.22a18.52,18.52,0,1,0,0-37Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkLinesHorizontal);
export default __webpack_public_path__ + "static/media/pink-lines-horizontal.e9342f4d7c08c39fadede34c3cee20fa.svg";
export { ForwardRef as ReactComponent };